export default __webpack_public_path__ + "static/media/cryptoloading.1be09601.gif";